import * as React from 'react'

import { cn } from 'components/UI/cn'

/**
 * DS2026 loading-placeholder bar. Size/shape it via `className`
 * (e.g. `h-4 w-1/2`, `size-8 rounded-full`).
 *
 * Adapted from the TailGrids skeleton. Uses `neutral-200` (the cool Tailwind
 * gray-200, not the warmer surface-disabled) + the built-in `animate-pulse`.
 * Decorative — rendered `aria-hidden`; replace with real content once it loads.
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-neutral-200', className)}
      {...props}
    />
  )
}
